module.exports = __webpack_public_path__ + "img/Mask Group 22.9584f5f0.svg";